import { render, staticRenderFns } from "./TextChatMessage.htm?vue&type=template&id=18bc3af8&scoped=true&"
import script from "./TextChatMessage.ts?vue&type=script&lang=js&"
export * from "./TextChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./TextChatMessage.scss?vue&type=style&index=0&id=18bc3af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc3af8",
  null
  
)

export default component.exports